"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dayjs = _interopRequireDefault(require("dayjs"));

var _calendarProvider = require("../calendar-provider");

var _SpeakerCard = require("./SpeakerCard.styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var socialTitle = {
  tw: 'Twitter',
  gh: 'Github',
  med: 'Medium',
  site: 'Site',
  default: 'Link'
};
var fallbackTechColor = 'white';

var selectQALink = function selectQALink(person) {
  try {
    return person.activities.talks[0].extension.qaLink;
  } catch (err) {
    return null;
  }
};

function SpeakerCard(_ref) {
  var type = _ref.type,
      content = _ref.content,
      status = _ref.status,
      hideLabel = _ref.hideLabel,
      calendarLinkOptions = _ref.calendarLinkOptions;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      minHeightTalkDesc = _useState2[0],
      setMinHeightTalkDesc = _useState2[1];

  var socialBtnRef = (0, _react.useCallback)(function (node) {
    if (node !== null && window.matchMedia('(min-width: 600px)').matches) {
      setMinHeightTalkDesc(node.getBoundingClientRect().height);
    }
  }, []);
  var person = content.data;
  var qaLink = selectQALink(person);
  var calendarLink = (0, _calendarProvider.createCalendarLink)(person, calendarLinkOptions);
  var techColor = person.tagBG && person.tagBG !== 'black' ? person.tagBG : fallbackTechColor;
  return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeaker, {
    id: "popup-".concat(person.slug)
  }, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerTop, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatarWrap, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerAvatar, {
    src: person.avatar,
    alt: person.name
  })), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerDesc, null, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerName, null, person.name), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerCompany, null, person.company), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, {
    dangerouslySetInnerHTML: {
      __html: person.bio
    }
  })), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerSocials, null, person.socials && /*#__PURE__*/_react.default.createElement("div", {
    ref: socialBtnRef
  }, person.socials.map(function (soc) {
    return /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBtn, {
      key: soc.link,
      href: soc.link,
      target: "_blank",
      rel: "noopener noreferrer"
    }, socialTitle[soc.icon] || socialTitle.default);
  })))), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerMid, {
    minHeight: minHeightTalkDesc
  }, person.activities && person.activities.talks ? person.activities.talks.map(function (talk) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: talk.title
    }, /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerActivityInfo, {
      color: techColor
    }, /*#__PURE__*/_react.default.createElement("span", null, !hideLabel ? talk.label : null), /*#__PURE__*/_react.default.createElement("span", null, talk.track.name), talk.timeString && /*#__PURE__*/_react.default.createElement("span", {
      title: "time is show in your local browser tme"
    }, (0, _dayjs.default)(talk.timeString).format('HH:mm'))), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerTitle, null, talk.title), /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopSpeakerBio, {
      dangerouslySetInnerHTML: {
        __html: talk.description
      }
    }), talk.timeString && calendarLink ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.PopCalendarButton, {
      title: "Add Talk to Calendar",
      href: calendarLink,
      target: "_blank",
      rel: "noopener noreferrer"
    }, "Add Talk to Calendar") : null);
  }) : null));
}

var _default = SpeakerCard;
exports.default = _default;